/**
 * @file index
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { View } from './components/View';
import { Text } from './components/Text';
import { Video } from './components/Video';
import { ScrollView } from './components/ScrollView';
import { Image } from './components/Image';
import { ResizeView } from './components/ResizeView';
import { Modal } from './components/Modal';
import { WebView } from './components/WebView';
import { Input } from './components/Input';
import { InlineText } from './components/InlineText';
import { PageView } from './components/PageView';
import { FixedView } from './components/FixedView';
import { Device } from './components/modules/DeviceModule';
export { ClassProvider } from './context/class';
export { PixelProvider } from './context/pixel';
export * from './utils/css';
export * from './utils/getRatio';
export * from './utils/linkTo';
export { enterFullScreen, exitFullScreen, getCurrentFullScreenElement } from './utils';
export var Components = {
    PageView: PageView,
    FixedView: FixedView,
    Input: Input,
    View: View,
    ScrollView: ScrollView,
    Image: Image,
    Modal: Modal,
    WebView: WebView,
    Text: Text,
    ResizeView: ResizeView,
    Video: Video,
    InlineText: InlineText,
    Device: Device,
};
export * from './hooks/useStyleTransform';
